import BsHScrollContainer from './index.vue'
export default BsHScrollContainer